module.exports = __webpack_public_path__ + "static/media/yoga-retreat-wellness-illustration.243aac08.svg";